import qs from "qs";
import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";
import api from "../../system/api";

const queryString = (query = {}) => qs.stringify(query, {encodeValuesOnly: true});

export class CustomerApi extends BaseStrapiCollection {
    constructor() { super("collectionType", "customer", "customers"); }
    list(query = {}) { return this.fetch(queryString(query)); }
    get(documentId, query = {}) { return this.find(documentId, query); }
    profile(documentId) { return this.action({}, `/customers/${documentId}/profile`); }
    fileAttached(documentId, files, dealDocumentId) { return this.postAction(`/customers/${documentId}/file-event`, {files, dealDocumentId}); }
    createCustomer(data, query = {}) { return this.create(data, query); }
    updateCustomer(documentId, data, query = {}) { return this.update(documentId, data, query); }
}

export class DealApi extends BaseStrapiCollection {
    constructor() { super("collectionType", "deal", "deals"); }
    createDeal(data, query = {}) { return this.create(data, query); }
    updateDeal(documentId, data) { return this.update(documentId, data); }
    changeStage(documentId, stage, version) { return this.postAction(`/deals/${documentId}/change-stage`, {stage, version}); }
    markWon(documentId, dealValue, version) { return this.postAction(`/deals/${documentId}/won`, {dealValue, version}); }
    markLost(documentId, lostReason, lostNote, version) { return this.postAction(`/deals/${documentId}/lost`, {lostReason, lostNote, version}); }
    reopen(documentId, stage, version) { return this.postAction(`/deals/${documentId}/reopen`, {stage, version}); }
}

export class DealProductApi extends BaseStrapiCollection {
    constructor() { super("collectionType", "deal-product", "deal-products"); }
    add(data) { return this.create(data); }
    change(documentId, data) { return this.update(documentId, data); }
    remove(documentId) { return this.delete(documentId); }
}

export class SalesProductApi extends BaseStrapiCollection {
    constructor() { super("collectionType", "sales-product", "sales-products"); }
    list(query = {}) { return this.fetch(queryString(query)); }
    add(data) { return this.create(data); }
}

export class LostReasonApi extends BaseStrapiCollection {
    constructor() { super("collectionType", "lost-reason", "lost-reasons"); }
    list(query = {}) { return this.fetch(queryString(query)); }
    add(title) { return this.create({title, isActive: true}); }
}

export class CrmNoteApi extends BaseStrapiCollection {
    constructor() { super("collectionType", "crm-note", "crm-notes"); }
    add(data) { return this.create(data); }
}

export class CrmTaskApi extends BaseStrapiCollection {
    constructor() { super("collectionType", "crm-task", "crm-tasks"); }
    add(data) { return this.create(data); }
    change(documentId, data) { return this.update(documentId, data); }
}

export class WorkspaceApiKeyApi extends BaseStrapiCollection {
    constructor() { super("collectionType", "workspace-api-key", "workspace-api-keys"); }
    list() { return this.fetch(""); }
    issue(data) { return this.create(data); }
    rotate(documentId) { return this.postAction(`/workspace-api-keys/${documentId}/rotate`); }
    revoke(documentId) { return this.postAction(`/workspace-api-keys/${documentId}/revoke`); }
}

export class CrmServiceConnectionApi extends BaseStrapiCollection {
    constructor() { super("singleType", "service-connections/crm", "service-connections/crm"); }
    getConnection() { return this.action({}, "/service-connections/crm"); }
    save(data) { return this.putAction("/service-connections/crm", data); }
    test() { return this.postAction("/service-connections/crm/test", {}); }
    link(linkCode) { return this.postAction("/service-connections/crm/link", {linkCode}); }
    async remove() {
        await this.waitForWorkspace();
        try {
            const response = await api.delete("/service-connections/crm", this.getHeader());
            return response.data;
        } catch (error) {
            throw this._normalizeError(error);
        }
    }
}
